import { ApiService } from 'services';

export const GET_LANGUAGES_REQUEST = 'GET_LANGUAGES_REQUEST';
export const GET_LANGUAGES_FAILURE = 'GET_LANGUAGES_FAILURE';
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS';

function request() {
  return {
    type: GET_LANGUAGES_REQUEST,
  };
}

function receive(data) {
  return {
    type: GET_LANGUAGES_SUCCESS,
    languages: data
  };
}

export function getLanguages() {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getLanguages()
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
      });
    return promise();
  };
}
